module.exports = __webpack_public_path__ + "static/img/presysv73.2ecdc56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv73.png
// module id = fW9q
// module chunks = 1